import { useEffect, useMemo } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { Site } from './types';

const AVAILABLE_SITES_ENDPOINT = '/gateway/api/available-sites';

export const addJPDSitesInOptions = (): string[] => ['jira-product-discovery'];

const fetchJiraAppLink = async () =>
	performPostRequest(AVAILABLE_SITES_ENDPOINT, {
		body: JSON.stringify({
			products: [
				'jira-software.ondemand',
				'jira-core.ondemand',
				'jira-servicedesk.ondemand',
				...addJPDSitesInOptions(),
			],
		}),
	});

export const transformJiraAppSites = (item: Site) => ({
	label: item.displayName,
	value: item.cloudId,
	url: item.url,
});

export const transformJiraAppSitesForSelect = (sites: Site[]) => sites.map(transformJiraAppSites);

const useFetchJiraAvailableSites = () => {
	const { loading, error, data, fetch } = useService(fetchJiraAppLink);

	useEffect(() => {
		fetch();
	}, [fetch]);

	const sites = useMemo(() => {
		if (data && data.sites && data.sites.length) return transformJiraAppSitesForSelect(data.sites);
		return [];
	}, [data]);

	return {
		isLoading: loading,
		error,
		sites,
	};
};

export default useFetchJiraAvailableSites;
